import 'css-chunksrc/client/scenes/resourceGroupEdition/styles.scss';export default {
  "main": "_main_ax41z_1",
  "buttons": "_buttons_ax41z_8",
  "loader": "_loader_ax41z_17",
  "loaderMain": "_loaderMain_ax41z_31"
};